import axios from "axios";

var path = null;
if (process.env.VUE_APP_TRS_ENDPOINT.endsWith("/api")) {
  // Si se define path, no se añade v2
  path = "/authorization/";
} else {
  path = "/v2/authorization/";
}
const TRS_ENDPOINT = process.env.VUE_APP_TRS_ENDPOINT + path;

export default {
  getAuthorization(token, permissions) {
    return axios.get(TRS_ENDPOINT + `?token=${token}&permissions=${permissions}`);
  }
};
